module.exports = __webpack_public_path__ + "static/media/money2.2e3870f3.jpg";